import Chip from "@mui/material/Chip";
import { StatusChipView } from "./branchStatus";

export default function ReadinessChip({ view }: Readonly<{ view: StatusChipView }>) {
  return <Chip size="small" label={view.label} color={view.color} />;
}
